<ng-container *ngIf="!sign?.complementInformationType">
  <div
    [ngClass]="[contrast ? 'contrast' : '', sign.signCode | enumCaption: 'Caption':width]"
    class="d-flex position-relative internal-caption"
    style="width: 75%"
  >
    <span>{{ sign?.verticalType != verticalSignTypeEnum.Indication ? sign.internalCaption : '' }}</span>
    <img src="{{ sign.svg }}" [style.width.px]="width" [style.height.px]="height" />
  </div>
</ng-container>

<ng-container *ngIf="sign.complementInformationType">
  <div
    [ngClass]="[contrast ? 'contrast' : '']"
    class="d-flex justify-content-center position-relative"
    [style.width.px]="width"
    [style.height.px]="height * 1.5"
  >
    <img
      *ngIf="sign.complementInformationType == complementInformationType.Additional"
      [src]="complementType(sign) | enumSvg: 'ComplementInformation'"
      [style.width.px]="width"
      [style.height.px]="height / 2"
      [style.bottom.px]="width / 8"
      style="position: absolute"
    />

    <img
      *ngIf="sign.complementInformationType == complementInformationType.Incorporated"
      [src]="complementType(sign) | enumSvg: 'ComplementInformation'"
      [style.width.px]="width"
      [style.height.px]="height * 1.5"
      [style.bottom.px]="width / 10"
      style="position: absolute"
    />

    <div
      [ngClass]="sign.signCode | enumCaption: 'Caption':width * 0.8"
      class="position-relative internal-caption"
      [style.width.px]="width * 0.8"
      [style.height.px]="height * 0.8"
    >
      <span *ngIf="width > 32" class="position-absolute" style="z-index: 1">{{
        sign?.verticalType != verticalSignTypeEnum.Indication ? sign.internalCaption : ''
      }}</span>
      <img
        [src]="sign.signCode | enumSvg: 'Signaling':signType"
        [style.width.px]="width * 0.8"
        [style.height.px]="height * 0.8"
        [style]="'position: absolute'"
      />
    </div>
  </div>
</ng-container>
